var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":"Logo"}}),_c('span',{staticClass:"bold-text"},[_vm._v("社会招聘")])]),_c('nav')])
}]

export { render, staticRenderFns }